export enum ModelProvider {
  ANTHROPIC = 'ANTHROPIC',
  OPENAI = 'OPENAI',
  GOOGLE = 'GOOGLE',
  META = 'META',
  MISTRAL = 'MISTRAL',
  DEEPSEEK = 'DEEPSEEK',
  XAI = 'XAI',
  COHERE = 'COHERE',
  PERPLEXITY = 'PERPLEXITY',
  TOGETHER_AI = 'TOGETHER_AI',
  HUGGINGFACE = 'HUGGINGFACE',
  CUSTOM = 'CUSTOM',
}

export enum Infrastructure {
  AWS_BEDROCK = 'AWS_BEDROCK',
  GCP_VERTEX = 'GCP_VERTEX',
  AZURE_OPENAI = 'AZURE_OPENAI',
  LOCAL_SELF_HOSTED = 'LOCAL_SELF_HOSTED',
  PROVIDER_API = 'PROVIDER_API',
  CLOUD_AGNOSTIC = 'CLOUD_AGNOSTIC',
}

export const PROVIDER_LABELS: Record<ModelProvider, string> = {
  [ModelProvider.ANTHROPIC]: 'Anthropic',
  [ModelProvider.OPENAI]: 'OpenAI',
  [ModelProvider.GOOGLE]: 'Google',
  [ModelProvider.META]: 'Meta (Llama)',
  [ModelProvider.MISTRAL]: 'Mistral AI',
  [ModelProvider.DEEPSEEK]: 'DeepSeek',
  [ModelProvider.XAI]: 'xAI (Grok)',
  [ModelProvider.COHERE]: 'Cohere',
  [ModelProvider.PERPLEXITY]: 'Perplexity',
  [ModelProvider.TOGETHER_AI]: 'Together AI',
  [ModelProvider.HUGGINGFACE]: 'Hugging Face',
  [ModelProvider.CUSTOM]: 'Custom Provider',
};

export const INFRASTRUCTURE_LABELS: Record<Infrastructure, string> = {
  [Infrastructure.AWS_BEDROCK]: 'AWS Bedrock',
  [Infrastructure.GCP_VERTEX]: 'GCP Vertex AI',
  [Infrastructure.AZURE_OPENAI]: 'Azure OpenAI',
  [Infrastructure.LOCAL_SELF_HOSTED]: 'Local / Self-Hosted',
  [Infrastructure.PROVIDER_API]: 'Provider API',
  [Infrastructure.CLOUD_AGNOSTIC]: 'Cloud Agnostic',
};

export const PROVIDER_OPTIONS = Object.entries(PROVIDER_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const INFRASTRUCTURE_OPTIONS = Object.entries(INFRASTRUCTURE_LABELS).map(([value, label]) => ({
  value,
  label,
}));
